import { nameFields } from "./individualName";
// src/utils/syncClientKyc.js

// client doc -> kyc.customer
export function clientToKycCustomer(clientDoc) {
  return {
    type: clientDoc?.clientType || "individual", // ✅ same values now
    name: clientDoc?.clientName || "",
    ...nameFields(clientDoc),
    // nationalityOrIncorporationCountry:
    //   clientDoc?.nationalityOrIncorporationCountry || "",
    email: clientDoc?.contactEmail || "",
    phone: clientDoc?.contactPhone || "",
    address: clientDoc?.address || "",
    city: clientDoc?.city || "",
    country: clientDoc?.country || "",
  };
}

// kyc.customer -> client doc fields
export function kycCustomerToClientFields(customer) {
  return {
    clientType: customer?.type || "individual", // ✅ same values now
    clientName: customer?.name || "",
    ...nameFields(customer),
    // nationalityOrIncorporationCountry:
    //   customer?.nationalityOrIncorporationCountry || "",
    contactEmail: customer?.email || "",
    contactPhone: customer?.phone || "",
    address: customer?.address || "",
    city: customer?.city || "",
    country: customer?.country || "",
  };
}
